import { Link } from "react-router-dom";
import { Heart, Mail } from "lucide-react";
import Logo from "./Logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { path: "/about", label: "About Us" },
      { path: "/terms", label: "Terms & Conditions" },
      { path: "/privacy", label: "Privacy Policy" },
      { path: "/disclaimer", label: "Disclaimer" },
      { path: "/copyright", label: "Copyright Policy" },
    ],
  };

  return (
    <footer 
      className="bg-[#F4F1EA] border-t border-[#E2E2E2]/50 mt-auto"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 lg:px-24 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-3 sm:space-y-4 text-center sm:text-left">
            <Logo className="justify-center sm:justify-start" />
            <p className="text-xs sm:text-sm text-[#5A5A5A] max-w-xs mx-auto sm:mx-0">
              Create fun, novelty certificates for entertainment purposes only.
            </p>
            <div className="flex items-center justify-center sm:justify-start gap-2 text-xs sm:text-sm text-[#888888]">
              <Mail className="w-3 h-3 sm:w-4 sm:h-4" />
              <span>support@lobe.love</span>
            </div>
          </div>

          {/* Legal Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold text-[#2D2D2D] mb-3 sm:mb-4 text-sm sm:text-base" style={{ fontFamily: "'Playfair Display', serif" }}>
              Legal
            </h4>
            <ul className="space-y-1 sm:space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-xs sm:text-sm text-[#5A5A5A] hover:text-[#E8A0BF] transition-colors duration-300"
                    data-testid={`footer-${link.label.toLowerCase().replace(/[&\s]/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Disclaimer */}
          <div className="sm:col-span-2 lg:col-span-1 text-center sm:text-left">
            <h4 className="font-semibold text-[#2D2D2D] mb-3 sm:mb-4 text-sm sm:text-base" style={{ fontFamily: "'Playfair Display', serif" }}>
              Important Notice
            </h4>
            <p className="text-[10px] sm:text-xs text-[#888888] leading-relaxed">
              LoBe certificates are for <strong>entertainment and novelty purposes only</strong>. 
              They have no legal validity and are not official documents. 
              They cannot be used for any legal, official, or formal purposes.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-[#E2E2E2]/50 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-[10px] sm:text-sm text-[#888888]">
            © {currentYear} LoBe. All rights reserved.
          </p>
          <div className="flex items-center gap-1 sm:gap-2 text-[10px] sm:text-sm text-[#888888]">
            <span>Made for</span>
            <Heart className="w-3 h-3 sm:w-4 sm:h-4 text-[#E8A0BF] fill-[#E8A0BF] animate-pulse" />
            <span>fun & entertainment</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
